import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  primary?: boolean;
  onClick?: () => void;
  className?: string;
}
const Button = ({
  children,
  primary = true,
  onClick,
  className = ''
}: ButtonProps) => {
  return <button onClick={onClick} className={`${primary ? 'bg-indigo-800 hover:bg-indigo-900 text-white' : 'bg-white hover:bg-gray-100 text-indigo-800 border border-indigo-800'} px-6 py-3 rounded-md font-semibold text-lg transition-all duration-200 ${className}`} data-id="element-521">
      {children}
    </button>;
};
export default Button;